export default __webpack_public_path__ + "static/icm-logo-67b91734beed8e64bd94f2b24096078e.svg";